<footer id="footer">
    <div class="footer-text justify-content-start gap-3 flex-nowrap d-flex align-items-baseline">
        <a [routerLink]="['/about']" id="about" jhiTranslate="aboutUs" class="col-auto"></a>
        <a [href]="FEEDBACK_URL" id="feedback" jhiTranslate="feedback" class="col-auto" target="_blank"></a>
        <a [href]="RELEASE_URL" id="releases" jhiTranslate="releases" class="col-auto" target="_blank"></a>
        <a [routerLink]="['/privacy']" id="privacy" jhiTranslate="artemisApp.legal.privacy" class="col-auto"></a>
        <a [routerLink]="['/imprint']" id="imprint" jhiTranslate="artemisApp.legal.imprint.title" class="col-auto"></a>
        @if (!isProduction || isTestServer) {
            <span class="col-auto footer-git footer-git-responsive">
                <small>
                    {{ gitBranch }} • {{ 'artemisApp.git.commit' | artemisTranslate }}: {{ gitCommitId }} • {{ 'artemisApp.git.timestamp' | artemisTranslate }}:
                    {{ gitTimestamp | artemisDate: 'short' }} • {{ gitCommitUser }}
                </small>
            </span>
        }
    </div>
</footer>
